import React from 'react';
import { Position } from 'reactflow';
import { Form, InputGroup } from 'react-bootstrap';
import CustomHandle from './CustomHandle';
import images from '../../../Utils/images';
import colors from '../../../Utils/colors';

interface AssignAIAssistantNodeProps {
    data: {
        assistant?: {
            name: string;
        };
    };
    isConnectable: boolean;
}

const handleStyle = {
    backgroundColor: '#FF9900',
    height: 15,
    width: 15,
    borderRadius: '100%'
};

const AssignAIAssistantNode: React.FC<AssignAIAssistantNodeProps> = ({ data, isConnectable }) => {
    return (
        <div
            className='d-flex flex-column justify-content-between align-items-center'
            style={{
                border: `1px solid ${colors.borderwhite}`,
                borderRadius: 16,
                backgroundColor: colors.white01,
                width: 230
            }}
        >
            <CustomHandle
                type="target"
                position={Position.Left}
                isConnectable={isConnectable}
                style={handleStyle}
            />

            <div
                className='w-100 d-flex flex-column justify-content-start align-items-center'
                style={{
                    paddingInline: 16,
                    paddingBlock: 8,
                    backgroundColor: '#FF9900',
                    borderTopLeftRadius: 16,
                    borderTopRightRadius: 16
                }}
            >
                <div style={{
                    height: 4,
                    width: '20%',
                    borderRadius: 2,
                    backgroundColor: colors.white,
                    marginBlockEnd: 4
                }} />
                <div className='w-100 d-flex flex-row justify-content-between align-items-center'>
                    <p style={{
                        padding: 0,
                        margin: 0,
                        fontSize: 16,
                        fontWeight: 700,
                        color: colors.white
                    }}>
                        Assign AI Assistant
                    </p>
                    <img
                        src={images.Edit}
                        alt="Edit"
                        style={{
                            height: 20,
                            width: 20,
                            objectFit: 'contain'
                        }}
                    />
                </div>
            </div>

            <div
                className='w-100 d-flex flex-column justify-content-start align-items-center'
                style={{
                    paddingInline: 16,
                    paddingBlockStart: 8,
                    paddingBlockEnd: 16,
                    backgroundColor: colors.white01,
                    borderBottomLeftRadius: 16,
                    borderBottomRightRadius: 16
                }}
            >
                <p style={{
                    padding: 0,
                    margin: 0,
                    marginBlock: 4,
                    fontSize: 12,
                    fontWeight: 400,
                    color: colors.black,
                    width: '100%'
                }}>
                    Chat will be assigned to AI Assistant
                </p>

                <div className="w-100 d-flex flex-column justify-content-start align-items-center"
                    style={{ paddingBlock: 8 }}
                >
                    <p style={{
                        padding: 0,
                        margin: 0,
                        marginBlock: 4,
                        fontSize: 10,
                        fontWeight: 600,
                        color: colors.black,
                        width: '100%',
                    }}>
                        Assistant
                    </p>
                    <InputGroup className="my-1">
                        <Form.Control
                            type="text"
                            placeholder="Select Assistant"
                            className="w-100 btncustom"
                            style={{
                                borderRadius: 8,
                                fontSize: 10,
                                fontWeight: 400,
                                color: colors.black
                            }}
                            maxLength={640}
                            value={data?.assistant?.name || ''}
                            readOnly
                        />
                    </InputGroup>
                </div>

                <CustomHandle
                    type="source"
                    position={Position.Right}
                    style={handleStyle}
                    isConnectable={1}
                />
            </div>
        </div>
    );
};

export default AssignAIAssistantNode;